module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Left.27ba32dd.svg";